// packages/common/colors.ts

export const GREY_COLORS = {
  25: '#fafafa',
  50: '#f5f5f5',
  100: '#f0f0f0',
  200: '#d9d9d9',
  300: '#bfbfbf',
  400: '#8c8c8c',
  500: '#595959',
  600: '#434343',
  700: '#262626',
  800: '#1f1f1f',
  900: '#141414',
  A50: '#fafafa',
  A100: '#bfbfbf',
  A200: '#434343',
  A400: '#1f1f1f',
  A700: '#121212',
  A800: '#d3d8db',
  transparent: 'rgba(0, 0, 0, 0)',
  boxShadowLight: 'rgba(12, 33, 70, 0.05)',
  avatarRingBackground: 'rgba(38, 38, 38, 0.08)',
  avatarShadow: 'rgba(12, 33, 70, 0.051)',
  black70: 'rgba(0, 0, 0, 0.7)',
};

export const BRAND_COLORS = {
  25: '#FAFAFA',
  50: '#FFFCFA',
  100: '#FFE3D1',
  200: '#FFC9A8',
  300: '#FFAF7F',
  400: '#FF9456',
  500: '#FF782D',
  600: '#FF5B04',
  700: '#D04400',
  800: '#9D3000',
  900: '#6A1F00',
  '600-12': 'rgba(255, 91, 4, 0.12)',
  '600-20': 'rgba(255, 91, 4, 0.2)',
  lighter: '#FFFCFA',
  light: '#FFAF7F',
  main: '#FF782D',
  dark: '#FF5B04',
  darker: '#9D3000',
};

export const VOLCANO_COLORS = {
  25: '#FAFAFA',
  50: '#FFFCFA',
  100: '#FFE3D1',
  200: '#FFC9A8',
  300: '#FFAF7F',
  400: '#FF9456',
  500: '#FF782D',
  600: '#FF5B04',
  700: '#D04400',
  800: '#9D3000',
  900: '#6A1F00',
};

export const CYAN_COLORS = {
  25: '#F6FEFE',
  50: '#EBFDFF',
  100: '#BAF8FE',
  200: '#8AF2FD',
  300: '#8AF2FD',
  400: '#0BD4E6',
  500: '#0BD4E6',
  600: '#097B85',
  700: '#075056',
  800: '#084044',
  900: '#062122#062122',
  '700-8': '#07505614 ',
  '700-24': 'rgba(7, 80, 86, 0.24)',
};

export const DUST_RED_COLORS = {
  50: '#FFF1F0',
  100: '#FFCCC7',
  200: '#FFA39E',
  300: '#FF7875',
  400: '#FF4D4F',
  500: '#F5222D',
  600: '#CF1322',
  700: '#A8071A',
  800: '#820014',
  900: '#5C0011',
  '600-20': 'rgba(207, 19, 34, 0.2)',
};

export const CALENDULA_GOLD_COLORS = {
  50: '#FFFBE6',
  100: '#FFF1B8',
  200: '#FFE58F',
  300: '#FFD666',
  400: '#FFC53D',
  500: '#FAAD14',
  600: '#D48806',
  700: '#AD6800',
  800: '#874D00',
  900: '#613400',
};

export const POLAR_GREEN_COLORS = {
  50: '#F6FFED',
  100: '#D9F7BE',
  200: '#B7EB8F',
  300: '#95DE64',
  400: '#73D13D',
  500: '#52C41A',
  600: '#389E0D',
  700: '#237804',
  800: '#135200',
  900: '#092B00',
};

export const PRIMARY_COLORS = {
  25: '#f0f5ff',
  lighter: '#e5edfb',
  100: '#cbdbf6',
  200: '#96b6ed',
  light: '#6292e5',
  400: '#2d6ddc',
  main: '#1d52ad',
  dark: '#17428c',
  700: '#123269',
  darker: '#0c2146',
  900: '#061123',
  primaryShadowColor: '#1D52AD33',
};

export const ERROR_COLORS = {
  50: '#fff1f0',
  100: '#ffccc7',
  200: '#ffa39e',
  300: '#ff7875',
  400: '#ff4d4f',
  main: '#f5222d',
  600: '#cf1322',
  700: '#a8071a',
  800: '#820014',
  900: '#5c0011',
  errorShadowColor: '#F5222D33',
  '600-12': 'rgba(207, 19, 34, 0.12)',
  '600-20': 'rgba(207, 19, 34, 0.20)',
};

export const WARNING_COLORS = {
  50: '#fffbe6',
  100: '#fff1b8',
  200: '#ffe58f',
  300: '#ffd666',
  400: '#ffc53d',
  main: '#faad14',
  600: '#d48806',
  700: '#ad6800',
  800: '#874d00',
  900: '#613400',
};

export const SUCCESS_COLORS = {
  50: '#f6ffed',
  100: '#d9f7be',
  200: '#b7eb8f',
  300: '#95de64',
  400: '#73d13d',
  main: '#52c41a',
  600: '#389e0d',
  700: '#237804',
  800: '#135200',
  900: '#092b00',
};

export const SUNSET_ORANGE = {
  50: '#fff7e6',
  100: '#ffe7ba',
  200: '#ffd591',
  300: '#ffc069',
  400: '#ffa940',
  500: '#fa8c16',
  600: '#d46b08',
  700: '#ad4e00',
  800: '#873800',
  900: '#612500',
};

// Service Desk Priority Colors
export const LOW_PRIORITY_COLOR = '#597EF7';
